import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { setAllEntities, setEntity, withEntities } from '@ngrx/signals/entities';
import { MgsWebApi } from '../../mgs-webapi.service';
import { computed, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IKidsPotentielle, IKidsPotentielleSuche } from '@mng/mgs-lib';

export interface IKidsPotentielleState {
  suche: IKidsPotentielleSuche;
}

export const KidsPotentielleStore = signalStore(
  { providedIn: 'root' },
  withState<IKidsPotentielleState>({ suche: undefined }),
  withEntities<IKidsPotentielle>(),
  withComputed((state) => ({
    loaded: computed(() => state.entities()?.length > 0),
    entitiesCopy: computed(() => structuredClone(state.entities()))
  })),
  withMethods((state) => {
    const webApi = inject(MgsWebApi);

    const load = async () => {
      const response = await firstValueFrom(webApi.kidsPotentielle(state.suche()));
      const kids = response.data.result.kids;
      patchState(state, setAllEntities(kids));
    };

    return {
      load,
      updateSuche: async (suche: IKidsPotentielleSuche) => {
        patchState(state, { suche });
        return load();
      },
      updateInMemory: (kid: IKidsPotentielle) => {
        patchState(state, setEntity(kid));
      },
      update: async (kid: IKidsPotentielle) => {
        const anzahlWartelisten = kid.anzahlWartelisten;
        const updatedKid = (await firstValueFrom(webApi.kidSpeichern(kid))).data.result;
        kid = { ...updatedKid, anzahlWartelisten };

        patchState(state, setEntity(kid));

        // nach jedem Update werden "einfach" die Daten neu geladen
        // das vereinfacht Konsistenzprobleme
        // (z.B. wenn sich der Termin verändert und ein Terminfilter aktiv wäre
        // oder ein Logincode geändert wird der sich auf mehrere Kinder niederschlägt)
        void load();
      },
      updateAll: (kids: IKidsPotentielle[]) => {
        patchState(state, setAllEntities(kids));
      }
    };
  })
);

export type KidsPotentielleStore = InstanceType<typeof KidsPotentielleStore>;
